module.exports = __webpack_public_path__ + "static/media/users.1c13d3b2.svg";